"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _createTransitionContext = require("../context/createTransitionContext");

var _jsxFileName = "/Users/tylerbarnes/Documents/GitHub/transitionlink-workspace/gatsby-plugin-transition-link/src/components/TransitionRenderer.js";

var TransitionRenderer =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(TransitionRenderer, _Component);

  function TransitionRenderer() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TransitionRenderer.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    // only rerender if the transition status changes.
    return this.props.transitionStatus !== nextProps.transitionStatus;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        mount = _this$props.mount,
        entryZindex = _this$props.entryZindex,
        exitZindex = _this$props.exitZindex,
        transitionStatus = _this$props.transitionStatus,
        transitionState = _this$props.transitionState,
        children = _this$props.children;
    return _react.default.createElement("div", {
      className: "tl-wrapper " + (mount ? "tl-wrapper--mount" : "tl-wrapper--unmount") + " tl-wrapper-status--" + transitionStatus,
      style: {
        zIndex: mount ? entryZindex : exitZindex
      },
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21
      },
      __self: this
    }, _react.default.createElement(_createTransitionContext.PublicProvider, {
      value: (0, _extends2.default)({}, transitionState),
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29
      },
      __self: this
    }, (0, _react.cloneElement)(children, (0, _extends2.default)({}, transitionState))));
  };

  return TransitionRenderer;
}(_react.Component);

exports.default = TransitionRenderer;